module.exports = __webpack_public_path__ + "static/Ezzeldin Tahoun.e85fe865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Ezzeldin Tahoun.jpg
// module id = 1212
// module chunks = 6166952557895